import React from "react";

const sizes = {
  textxs: "text-[8px] font-normal",
  texts: "text-[10px] font-normal",
  textmd: "text-[11px] font-normal",
  textlg: "text-[13px] font-normal",
  textxl: "text-[14px] font-normal",
  text2xl: "text-[15px] font-normal",
  text3xl: "text-[16px] font-normal",
  text4xl: "text-[17px] font-normal",
  text5xl: "text-[18px] font-normal",
  text8xl: "text-[22px] font-normal",
  text9xl: "text-[24px] font-normal md:text-[22px]",
  text10xl: "text-[25px] font-normal md:text-[23px] sm:text-[21px]",
  text11xl: "text-[26px] font-normal md:text-[24px] sm:text-[22px]",
};

const Text = ({ children, className = "", as, size = "text5xl", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`font-spacegrotesk ${className} ${sizes[size]} `} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
